import React from "react"

function contentLoader(WrappedComponent) {
    const component = ({ isFetching, children, ...props }) => {
        if (isFetching) {
            return <WrappedComponent {...props} />
        } else {
            return children || null
        }
    }
    return component
}

export default contentLoader
